import { React, useState, useEffect } from 'react';
import style from './../adminSect.module.scss';
import Stands from './Stands';
import axios from './../../../config/apiConfig';

const StandsTable = () => {
  const {
    sectHeader,
    usersTableHeader,
    headerTitle,
    halls,
    standTitleH,
    hActive,
    notActive,
    activeTitle,
  } = style;

  const [hall, setHall] = useState('medicine');
  const [hallStands, setHallStands] = useState([]);
  const [hallState, setHallState] = useState('noReq');

  useEffect(async () => {
    try {
      setHallState('noReq');
      const opt = {
        perfume: 'perfumeria', 
        cosmetic: 'dermocosmetica', 
        medicine: 'medicamentos' 
      };
      const { data } = await axios.get(`/stands?section=${opt[hall]}`);
      setHallState(data.status);
      setHallStands(data.data);
    } catch (error) {
      console.log(error); // eslint-disable-line
    }
  }, [hall]);

  const hallActive = (h3Hall, title) => {
    if (h3Hall === hall) {
      if (title) {
        return activeTitle;
      }
      return hActive;
    } else {
      if (title) {
        return '';
      }
      return notActive;
    }
  };

  const toggleModal = (setState) => setState((state) => !state);

 

  return (
    <div>
      <div className={`${sectHeader} ${usersTableHeader}`}>
        <div className={`${headerTitle} ${standTitleH}`} style={{justifyContent: 'unset'}}>
          <h1 style={{marginLeft:'3rem'}}>
            <b>Stand</b>
          </h1>
        </div>
        <div className={halls}>
          <div onClick={() => setHall('medicine')}>
            <h3 className={hallActive('medicine', true)}>
              Halls 1: Medicamento
            </h3>
            <span className={hallActive('medicine')}></span>
          </div>
          <div onClick={() => setHall('perfume')}>
            <h3 className={hallActive('perfume', true)}>Halls 2: Perfumeria</h3>
            <span className={hallActive('perfume')}></span>
          </div>
          <div onClick={() => setHall('cosmetic')}>
            <h3 className={hallActive('cosmetic', true)}>
              Halls 3: Dermocosmética
            </h3>
            <span className={hallActive('cosmetic')}></span>
          </div>
        </div>
      </div>

      <Stands toggleModal={toggleModal} hallStands={hallStands} setHallStands={setHallStands} hall={hall} hallState={hallState}/>
    </div>
  );
};
export default StandsTable;
